// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"226783b4","453":"6ca1ecc1","553":"f5b1b228","977":"9961e219"}[chunkId] + ".chunk.js";
};